module.exports = __webpack_public_path__ + "img/baohua.5a14b45f.jpg";